"use client";

import { useEffect, useState } from "react";
import BgLatto from "../../assets/images/bg-keypad.png";

export default function DrawTimer({ drawTime, drawDate }) {
  const [time, setTime] = useState({ hours: 2, minutes: 10, seconds: 7 });

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prev) => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        }
        if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        }
        if (prev.hours > 0) {
          return { hours: prev.hours - 1, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className=" flex  justify-between items-center rounded-lg px-2.5 py-3 mx-4 border border-white"
    style={{
      backgroundImage: `url(${BgLatto})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
    >
      <div>
        <div className="flex items-center gap-1">
          <div className="text-white text-3xl font-semibold ">OPEN</div>
          <div className="text-[#FFE500] text-[12px] leading-none font-semibold">
            {drawTime} <br />
            DRAW
          </div>
        </div>
        <div className="text-[#6D7388] text-xs leading-none">{drawDate}</div>
      </div>
      <div className="flex gap-1.5 ">
        <TimeBox value={time.hours} label="Hour" />
        <TimeBox value={time.minutes} label="Minute" />
        <TimeBox value={time.seconds} label="Second" />
      </div>
    </div>
  );
}

function TimeBox({ value, label }) {
  return (
    <div className="bg-white rounded w-12 h-[50px] flex items-center justify-center flex-col ">
      <div className="text-2xl font-semibold mt-0.5">
        {value.toString().padStart(2, "0")}
      </div>
      <div className=" text-[10px] mb-1">{label}</div>
    </div>
  );
}
